<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Vacantes</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( vacantes  , 'vacantes_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="vacantes"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>
							  

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="error" 
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_plantel }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="editedItem.idpuesto"
            :items="puestosAll"
            label="Puesto"
            item-value="idpuesto"
            item-text="puesto"
            filled
            dense
          ></v-autocomplete>
          
          <v-autocomplete
            v-model="editedItem.sucursal"
            :items="sucursales"
            label="Sucursal"
            item-value="id_plantel"
            item-text="plantel"
            filled
            dense
          ></v-autocomplete>
          
          <v-select
            v-model="editedItem.horario"
            :items="['Día', 'Tarde', 'Noche', 'Completo']"
            label="Horario"
            filled
            dense
          ></v-select>

          <v-autocomplete
            v-model="editedItem.reclutadora"
            :items="reclutadoras"
            label="Reclutadora"
            item-value="iderp"
            item-text="name" 
            filled
            dense         
          ></v-autocomplete>

          <v-text-field
            v-model="editedItem.fecha_entrega"
            type="date"
            label="fecha compromiso"
            filled
            dense
          ></v-text-field>

          <label>Para cerrar la vacante, selecciona un trabajador</label>
          <v-autocomplete
            v-model="editedItem.reclutadora"
            :items="trabajadores"
            label="Trabajador"
            item-value="id_trabajador"
            item-text="nombre_completo" 
            filled
            dense         
          ></v-autocomplete>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idvacantes:0,
        fecha_entrega: null,
				sucursal: 0,
				horario: null,
				idpuesto: 0,
				reclutadora: 0,
				urgencia:1,
				deleted: 0,
				proceso:0,
				capacitacion:0,
      },

      defaultItem: {
        idvacantes:0,
        fecha_entrega: null,
				sucursal: 0,
				horario: null,
				idpuesto: 0,
				reclutadora: 0,
				urgencia:1,
				deleted: 0,
				proceso:0,
				capacitacion:0,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      vacantes: [],
      puestos:[],
      sucursales:[],
      reclutadoras:[],
      trabajadores:[],

      headers: [
	      { text: "Id"              , value: "idvacantes"        },
	      { text: "Puesto"          , value: "puesto"            },
	      { text: "Plantel"         , value: "plantel"           },     
	      { text: "Horario"         , value: "horario"           },     
	      { text: "Reclutadora"     , value: "nombre_completo"   },
	      { text: "Fecha Compromiso", value: "fecha_entrega"     },     
	      // { text: "Urgencia"        , value: "urgencia"          },
	      { text: "Tiempo"          , value: "dias_transcurrido" },
        { text: 'Actions'         , value: 'actions', sortable: false },
	    ],
      puestosAll:[]
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar vacante' : 'Editar vacante'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
      await this.getPlanteles()
      await this.getTrabajadores()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.vacantes = []
        return this.$http.get('vacantes.list').then(response=>{
        	this.vacantes      = response.data.vacantes
          this.puestos       = response.data.puestos
        	this.puestosAll    = response.data.puestos
        	this.reclutadoras  = response.data.reclutadoras
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.sucursales = []
        return this.$http.get('planteles.list.erp').then(response=>{
        	this.sucursales = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getTrabajadores () {  
        this.cargar = true
        this.trabajadores = []
        return this.$http.get('trabajadores.erp.get.trabajadoreserp', {
          params: { activos: 'Activos' },
        }).then(response=>{

          this.trabajadores = Array.isArray(response.data) ? response.data : []

          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : 'Error al cargar trabajadores' )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.vacantes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.vacantes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        // Lo mandapos por el EP
        this.$http.post(`organigrama.updatevacantes`, this.editedItem).then((response) => {
          this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch((error) => {
          this.validarError( error.response.data.message )
        }).finally(() => { this.cargar = false });

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	// Cargamos al usuario que hizo el cambio
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.post(`organigrama.updatevacantes`, this.editedItem).then((response) => {
	          this.initialize()
	        	this.cargar = false
        		this.close()
	        }).catch((error) => {
	          this.validarError( error.response.data.message )
	        }).finally(() => { this.cargar = false });

        } else {
        	this.$http.post(`organigrama.vacante`, this.editedItem).then((response) => {
	          this.initialize()
	        	this.cargar = false
        		this.close()
	        }).catch((error) => {
	          this.validarError( error.response.data.message )
	        }).finally(() => { this.cargar = false });
        }
      },
    },
  }
</script>


